<template>
  <div class="view-container" style="margin: auto;">
    <p class="title-text">{{lang=='en' ? 'Failed!':'생성 실패!'}}</p>
    <p class="title-text">{{lang=='en' ? 'Please refresh and retry again.':'새로고침 후 다시 시도하세요.'}}</p>
    <b-button block size="lg" variant="primary" @click="goHomeEmit" style="font-size: 48px; width: 400px; margin: auto">{{lang=='en' ? 'Go to Home':'메인 화면으로 이동'}}</b-button>
  </div>
</template>

<script>
export default {
  name: 'FailedPageView',

  props: {
    lang: {
      type: String,
      required: true
    },
  },

  methods: {
    goHomeEmit() {
      this.$emit('goHome')
    }
  }
}
</script>

<style scoped>
.view-container {
  display: flex;
  flex-direction: column;
}
</style>